import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

export const AbilityContext = createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  can: (_action: string, _subject: any, _field?: string) => false as boolean,
});
export default createContextualCan(AbilityContext.Consumer);
